import styled from 'styled-components/macro';

export const FinancialDataFormWrapper = styled.div``;
